import { Directive, inject, Input, signal, TemplateRef, ViewContainerRef } from "@angular/core";
import { FeatureToggleService } from "../services/featuretoggle.service";
import { NgIfContext } from "@angular/common";

@Directive({
    selector: '[featureActive]'
})
export class FeatureToggleDirective {
    templateRef = inject(TemplateRef);
    viewContainer = inject(ViewContainerRef);
    featureToggleService = inject(FeatureToggleService);
    elseTemplateRef = null;
    hasToggles = signal(false);

    @Input() set featureActive(features: string[]) {
        this.hasToggles.set(features.some((ft) => this.featureToggleService.getFeatureToggle(ft)));
        this.updateView();
    }

    @Input() set featureActiveElse(templateRef: TemplateRef<NgIfContext> | null) {
        if (templateRef !== undefined) {
            this.elseTemplateRef = templateRef
        }
        this.updateView();
    }

    private updateView(): void {
        this.viewContainer.clear();
        if (this.elseTemplateRef && !this.hasToggles()) {
            this.viewContainer.createEmbeddedView(this.elseTemplateRef);
        } else if (this.templateRef && this.hasToggles()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}